import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { PanelModule } from 'primeng/panel';
import { TooltipModule } from 'primeng/tooltip';
import { createSettingsSignal } from '../../../../../@core/services/settings.service';
import { SettingType } from '../../../../../generated/generated-types';
import { PhxCheckboxComponent } from '../../../../../shared/components/phx-input-checkbox/phx-input-checkbox.component';
import { ProductDispositionOverviewListComponent } from '../product-disposition-overview-list.component';

@Component({
  selector: 'app-product-disposition-overview-panel',
  templateUrl: './product-disposition-overview-panel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    FormsModule,
    TranslatePipe,
    PhxCheckboxComponent,
    TooltipModule,
    PanelModule,
    ProductDispositionOverviewListComponent,
  ],
})
export class ProductDispositionOverviewPanelComponent {
  readonly productId = input.required<string>();

  readonly groupLot = createSettingsSignal(SettingType.S_WAREHOUSE_GROUP_LOT, true);
  readonly groupStoragePlace = createSettingsSignal(SettingType.S_WAREHOUSE_GROUP_STORAGE_PLACE, true);
  readonly groupRootStoragePlace = createSettingsSignal(SettingType.S_WAREHOUSE_GROUP_ROOT_STORAGE_PLACE, false);
  readonly groupSerial = createSettingsSignal(SettingType.S_WAREHOUSE_GROUP_SERIAL, true);
}
